/* =========================================================================
   Ripe & Ready — box builder behaviour.

   Reads its data from the #rr-builder-data JSON block that the section
   renders, so prices, variant ids and Loop plan ids all come from Shopify and
   never from this file.

   Depends on rr-areas.js and rr-delivery.js.
   ========================================================================= */
(function () {
  "use strict";

  var root = document.getElementById("rr-builder");
  var dataEl = document.getElementById("rr-builder-data");
  if (!root || !dataEl) {
    return;
  }

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var esc = (window.RR && window.RR.esc) || function (t) { return String(t); };

  /* ---------------------------------------------------------------- state */
  var state = {
    postcode: "",
    suburb: "",
    box: null,
    freq: null
  };

  var steps = root.querySelectorAll(".fstep");
  var bars = document.getElementById("rr-progress").children;
  var plabel = document.getElementById("rr-plabel");
  var LABELS = ["Where you live", "Check it over"];

  function show(n) {
    for (var i = 0; i < steps.length; i++) {
      if (i === n - 1) {
        steps[i].setAttribute("data-on", "1");
      } else {
        steps[i].removeAttribute("data-on");
      }
    }
    for (var j = 0; j < bars.length; j++) {
      bars[j].className = j <= n - 1 ? "on" : "";
    }
    plabel.textContent = "Step " + n + " of 2 — " + LABELS[n - 1];
    placeCode(n);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* One code box, moved into the slot of whichever step is showing. */
  function placeCode(n) {
    var codeBox = document.getElementById("rr-code");
    var slot = document.getElementById("rr-code-slot-" + n);
    if (codeBox && slot && codeBox.parentNode !== slot) { slot.appendChild(codeBox); }
  }

  function boxByKey(k) {
    for (var i = 0; i < DATA.boxes.length; i++) {
      if (DATA.boxes[i].key === k) { return DATA.boxes[i]; }
    }
    return null;
  }

  function freqByKey(k) {
    for (var i = 0; i < DATA.freqs.length; i++) {
      if (DATA.freqs[i].key === k) { return DATA.freqs[i]; }
    }
    return null;
  }

  /* -------------------------------------------------------------- step 1a */
  var pcInput = document.getElementById("rr-f-pc");
  var subSel = document.getElementById("rr-f-sub");
  var locMsg = document.getElementById("rr-loc-msg");
  var locNav = document.getElementById("rr-loc-nav");
  var locEdit = document.getElementById("rr-loc-edit");
  var locDone = document.getElementById("rr-loc-done");
  var locTxt = document.getElementById("rr-loc-txt");
  var blkBuild = document.getElementById("rr-blk-build");
  var pending = null;

  function resetSuburbs(msg) {
    subSel.innerHTML = '<option value="">' + msg + "</option>";
    subSel.disabled = true;
    locNav.hidden = true;
    pending = null;
  }

  pcInput.addEventListener("input", function () {
    var pc = pcInput.value.trim();
    locMsg.innerHTML = "";
    if (!/^\d{4}$/.test(pc)) {
      resetSuburbs("Enter a postcode first");
      return;
    }
    var res = window.RR.checkPostcode(pc);
    if (!res.ok) {
      resetSuburbs("Not in our area yet");
      locMsg.innerHTML =
        '<p class="mono" style="font-size:14px">Not yet, sorry. We\'re adding suburbs as the ' +
        "routes fill up.</p>";
      return;
    }
    var html = '<option value="">Choose your suburb</option>';
    res.suburbs.forEach(function (s) {
      html += '<option value="' + esc(s) + '">' + esc(s) + "</option>";
    });
    res.near.forEach(function (s) {
      html += '<option value="OUT:' + esc(s) + '">' + esc(s) + " (outside the run)</option>";
    });
    subSel.innerHTML = html;
    subSel.disabled = false;
    subSel.focus();
  });

  subSel.addEventListener("change", function () {
    var v = subSel.value;
    locMsg.innerHTML = "";
    locNav.hidden = true;
    pending = null;
    if (!v) { return; }

    if (v.indexOf("OUT:") === 0) {
      locMsg.innerHTML =
        '<p class="mono" style="font-size:14px">' +
        esc(v.slice(4)) + " sits just outside the run, sorry. We're adding suburbs as we grow.</p>";
      return;
    }

    pending = { suburb: v, postcode: pcInput.value.trim() };
    locMsg.innerHTML =
      '<p class="mono" style="font-size:14px"><span style="color:var(--stamp);font-weight:600">' +
      "Yes, we come to " + esc(v) + ".</span> " + esc(DATA.windowText) + ". Delivery is free.</p>";
    locNav.hidden = false;
  });

  document.getElementById("rr-loc-continue").addEventListener("click", function () {
    if (!pending) { return; }
    state.postcode = pending.postcode;
    state.suburb = pending.suburb;
    locMsg.innerHTML = "";
    locNav.hidden = true;
    locEdit.hidden = true;
    locDone.hidden = false;
    locTxt.innerHTML =
      "Delivering to <strong>" + esc(state.suburb) + " " + esc(state.postcode) +
      "</strong> &middot; " + esc(DATA.windowText) + " &middot; Free Delivery";
    blkBuild.hidden = false;
    plabel.textContent = "Step 1 of 2 — Which box suits you?";
    blkBuild.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  document.getElementById("rr-loc-change").addEventListener("click", function () {
    /* Change undoes the confirmation completely. It used to only reopen the
       fields, which left the box picker on screen and left the OLD suburb in
       state. A customer could then type a postcode we do not deliver to, pick
       a box, and check out — and the order would carry the address they had
       already replaced. Both halves of that were wrong, so both are undone
       here: the picker closes and the confirmed address is cleared. */
    state.postcode = "";
    state.suburb = "";
    pending = null;
    locDone.hidden = true;
    locEdit.hidden = false;
    locMsg.innerHTML = "";
    locNav.hidden = true;
    blkBuild.hidden = true;
    plabel.textContent = "Step 1 of 2 — " + LABELS[0];
    pcInput.focus();
    pcInput.select();
  });

  /* -------------------------------------------------------------- step 1b */
  var bcImg = document.getElementById("rr-bc-img");
  var bcTitle = document.getElementById("rr-bc-title");
  var bcMeta = document.getElementById("rr-bc-meta");
  var bcList = document.getElementById("rr-bc-list");
  var bcInside = document.getElementById("rr-bc-inside");

  /* All three sizes share one <img>. Assigning .src leaves the old photo on
     screen until the new file decodes, so tapping Medium kept showing Small
     for a moment and then jumped. Two fixes, both needed:

       1. Fetch every box photo once, as soon as the builder script runs. The
          postcode step takes the shopper several seconds, which is far longer
          than the 162 KB needs, so by the time the sizes appear they are all
          in cache and the swap is instant.
       2. Never leave a photo that belongs to a different box. If a file is
          somehow not ready, fade the frame instead of showing the wrong one,
          and drop the result if a later tap has already won the race. */
  var photoCache = {};
  var photoTurn = 0;

  function cachePhoto(src) {
    if (!src) { return null; }
    if (!photoCache[src]) {
      var im = new Image();
      im.decoding = "async";
      im.src = src;
      photoCache[src] = im;
    }
    return photoCache[src];
  }

  function preloadPhotos() {
    DATA.boxes.forEach(function (b) { cachePhoto(b.img); });
  }

  function setPhoto(src, alt) {
    var mine = ++photoTurn;
    var pre = cachePhoto(src);
    function show() {
      if (mine !== photoTurn) { return; }
      bcImg.src = src;
      bcImg.alt = alt;
      bcImg.classList.remove("is-swapping");
    }
    if (pre.complete && pre.naturalWidth > 0) { show(); return; }
    bcImg.classList.add("is-swapping");
    pre.addEventListener("load", show, { once: true });
    pre.addEventListener("error", function () {
      if (mine !== photoTurn) { return; }
      bcImg.classList.remove("is-swapping");
    }, { once: true });
  }

  function paintCard() {
    var b = boxByKey(state.box);
    if (!b) { return; }
    bcTitle.textContent = b.name + " box";
    /* The price is on the size buttons directly below this panel, so printing
       it here as well said the same number twice in one glance. */
    bcMeta.textContent = b.meta || "";
    if (b.img) {
      bcImg.hidden = false;
      setPhoto(b.img, b.alt || "");
    } else {
      photoTurn++;
      bcImg.hidden = true;
    }
    /* A size block can carry its own list; none of them does today, so all
       three fall back to the one shared list in theme settings. Run together
       with dots rather than set as a <ul>: fourteen bullets inside a card
       that is already a form reads as another set of choices to make, and
       none of these is a choice. */
    var src = (b.inside && b.inside.length ? b.inside : DATA.insideDefault) || [];
    var items = src.map(function (x) { return String(x).trim(); })
      .filter(function (x) { return x.length > 0; });
    var html = "";
    if (items.length) {
      html += "<p>" + esc(DATA.insideLead || "") + " " +
        items.map(esc).join(" &middot; ") + ".</p>";
    }
    if (DATA.insideNote) {
      html += "<p class=\"bc-list-note\">" + esc(DATA.insideNote) + "</p>";
    }
    bcList.innerHTML = html;
  }

  function syncPicks() {
    root.querySelectorAll("[data-box]").forEach(function (b) {
      b.setAttribute("aria-checked", b.getAttribute("data-box") === state.box ? "true" : "false");
    });
    root.querySelectorAll("[data-freq]").forEach(function (b) {
      b.setAttribute("aria-checked", b.getAttribute("data-freq") === state.freq ? "true" : "false");
    });
    paintCard();
  }

  root.querySelectorAll("[data-box]").forEach(function (b) {
    b.addEventListener("click", function () {
      state.box = b.getAttribute("data-box");
      syncPicks();
      recheckSoon();
    });
  });

  root.querySelectorAll("[data-freq]").forEach(function (b) {
    b.addEventListener("click", function () {
      state.freq = b.getAttribute("data-freq");
      syncPicks();
      recheckSoon();
    });
  });

  bcInside.addEventListener("click", function () {
    var open = bcList.hasAttribute("hidden");
    if (open) {
      bcList.removeAttribute("hidden");
    } else {
      bcList.setAttribute("hidden", "");
    }
    bcInside.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* --------------------------------------------------------------- step 2 */
  /* The line above the checkout button. It carries the first delivery date and
     nothing else, so the last thing read before paying answers "when". */
  var firstNote = document.getElementById("rr-first-note");
  var firstNoteTemplate = firstNote ? firstNote.textContent.trim() : "";

  function fillFirstNote() {
    if (!firstNote) {
      return;
    }
    var text = firstNoteTemplate;
    if (text.indexOf("{date}") === -1) {
      /* The wording was edited and the token dropped. Say the date anyway
         rather than showing a line with no date in it at all. */
      text = "Order now and your first delivery will be {date}.";
    }
    firstNote.textContent = text.replace("{date}", window.RR.nextDeliveryText());
  }

  function fillSummary() {
    var b = boxByKey(state.box);
    var f = freqByKey(state.freq);
    document.getElementById("rr-s-where").textContent = state.suburb + " " + state.postcode;
    document.getElementById("rr-s-box").textContent = b ? b.name + " box" : "—";
    document.getElementById("rr-s-freq").textContent = f ? f.label : "—";
    document.getElementById("rr-s-first").textContent = window.RR.nextDeliveryText();
    paintTotal();
  }

  document.getElementById("rr-to-review").addEventListener("click", function () {
    /* The box may have changed since a code was accepted, and a code can be
       good on one size and not another, so check it again against this box. */
    applied = null;
    fillSummary();
    fillFirstNote();
    show(2);
    /* This is where the box goes into the cart: the shopper has picked a
       size and a frequency and asked to go on. Shopify reports every
       /cart/add.js to the ad pixels as an "add to cart", so the add has to
       happen once, here, at the moment that means it (see buildCart). A code
       check builds the cart itself; without a code, build it directly. A
       failure stays quiet here: the checkout button builds again and says
       what went wrong. */
    if (wantedCode) {
      tryCode(wantedCode);
    } else {
      buildCart(true).catch(function () {});
    }
  });

  document.getElementById("rr-to-build").addEventListener("click", function () {
    show(1);
  });

  root.querySelectorAll("[data-edit]").forEach(function (b) {
    b.addEventListener("click", function () {
      var target = document.getElementById(b.getAttribute("data-edit"));
      show(1);
      if (!target) { return; }
      setTimeout(function () {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 60);
    });
  });

  /* ------------------------------------------------------------- checkout */
  var errBox = document.getElementById("rr-err");
  var payBtn = document.getElementById("rr-checkout");

  function fail(msg) {
    errBox.innerHTML = '<p class="mono" style="font-size:14px;color:var(--flag)">' + esc(msg) + "</p>";
    payBtn.disabled = false;
    payBtn.textContent = payBtn.getAttribute("data-label");
  }

  payBtn.setAttribute("data-label", payBtn.textContent.trim());

  /* The address in state must still be one we deliver to, every time. The step
     order is meant to guarantee that, but any future change to the flow could
     break it again, and the cost of getting it wrong is a paid order we cannot
     deliver. So it is checked here as well, at the last possible moment. */
  function addressOk() {
    if (!state.postcode || !state.suburb) {
      return false;
    }
    var res = window.RR.checkPostcode(state.postcode);
    if (!res || !res.ok) {
      return false;
    }
    return res.suburbs.indexOf(state.suburb) !== -1;
  }

  /* Every check a box has to pass before it can go in the cart. Returns the
     problem in words, or "" when there is none. */
  function cartProblem(b, f) {
    if (!b || !f) { return "Pick a box size and how often you want it."; }
    if (!b.variant) { return "That box is not set up in the store yet. Please try another size."; }
    if (!f.plan) { return "That delivery frequency is not set up yet. Please try the other one."; }
    if (!b.available) { return "That box is out of stock this week. Please try another size."; }
    return "";
  }

  function noteText() {
    var el = document.getElementById("rr-note");
    return el ? el.value.trim().slice(0, 500) : "";
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body || {})
    });
  }

  /* Puts exactly the chosen box in the cart, with the address, the date and
     the discount code, and resolves with the cart Shopify sends back.

     A returning customer must not end up with two boxes, so clear first.
     clear.js empties the line items but LEAVES cart attributes behind, so an
     address from an earlier visit would ride along on this order. A wrong
     address on the run sheet is worse than a missing one, so wipe them too
     before writing the new ones.

     Both the code check and the checkout button build the cart. Run side by
     side, their clear and add steps can interleave and leave two boxes in
     the cart, so every build waits for the one before it.

     Shopify reports every /cart/add.js to the Meta and Google pixels as an
     "add to cart" (checked live: one add, one product_added_to_cart). So a
     build must never add a box the cart already holds, or one shopper shows
     up in the ad numbers as two or three. Every caller therefore builds
     quick: when the last build left exactly this box in the cart, it sends
     only the last step, and keeps that answer when the cart Shopify sends
     back still holds exactly this box, once. If it does not, it falls back
     to the full build. That check is what makes it safe for the checkout
     button too, and it takes that button from four requests (3 to 5
     seconds) to one.

     The box goes in at three moments only: Continue, a code check made
     before Continue, and a change of size or frequency while a code is on.
     Opening the code box used to build the cart early to make Apply fast;
     that reported an add to cart for a tap on a link, so it is gone. */
  var cartQueue = Promise.resolve();
  /* What the last build left in the cart, as variant:plan. The quick try is
     only worth a request when it matches the box chosen now. */
  var cartKey = "";

  function cartHolds(cart, b, f) {
    var it = cart && cart.items && cart.items.length === 1 ? cart.items[0] : null;
    return !!it && it.quantity === 1 &&
      Number(it.variant_id) === Number(b.variant) &&
      !!it.selling_plan_allocation &&
      Number(it.selling_plan_allocation.selling_plan.id) === Number(f.plan);
  }

  function buildCart(quick) {
    var run = function () {
      var b = boxByKey(state.box);
      var f = freqByKey(state.freq);
      var problem = cartProblem(b, f);
      if (problem) { return Promise.reject(new Error(problem)); }
      var firstText = window.RR.nextDeliveryText();
      var firstISO = window.RR.nextDelivery().toISOString().slice(0, 10);

      /* Suburb, postcode and date ride on the order to the run sheet. The
         code goes on in the same call. An empty string takes off any code
         an earlier visit left on the cart. */
      var finish = function () {
        return postJSON("/cart/update.js", {
          attributes: {
            Suburb: state.suburb,
            Postcode: state.postcode,
            "Delivery day": DATA.dayName,
            "Delivery window": DATA.windowText,
            "First delivery": firstText,
            "First delivery date": firstISO
          },
          discount: wantedCode,
          /* Always sent, blank or not, so a note from an earlier visit
             cannot ride along on this order. */
          note: noteText()
        }).then(function (r) {
          if (!r.ok) { throw new Error("Please try again."); }
          return r.json();
        });
      };

      var full = function () {
        return postJSON("/cart/clear.js")
          .then(function () {
            return postJSON("/cart/update.js", {
              attributes: {
                Suburb: "",
                Postcode: "",
                "Delivery day": "",
                "Delivery window": "",
                "First delivery": "",
                "First delivery date": ""
              }
            });
          })
          .then(function () {
            return postJSON("/cart/add.js", {
              items: [{ id: b.variant, quantity: 1, selling_plan: f.plan }]
            });
          })
          .then(function (r) {
            if (!r.ok) { return r.json().then(function (j) { throw new Error(j.description || j.message); }); }
            return finish();
          });
      };

      var key = b.variant + ":" + f.plan;
      var done = function (cart) {
        cartKey = cartHolds(cart, b, f) ? key : "";
        return cart;
      };
      if (!quick || cartKey !== key) { return full().then(done); }
      return finish().then(function (cart) {
        return cartHolds(cart, b, f) ? done(cart) : full().then(done);
      });
    };
    var p = cartQueue.then(run, run);
    cartQueue = p.catch(function () {});
    return p;
  }

  payBtn.addEventListener("click", function () {
    errBox.innerHTML = "";

    if (!addressOk()) {
      fail("Please check your postcode and suburb again before you order.");
      show(1);
      return;
    }
    var problem = cartProblem(boxByKey(state.box), freqByKey(state.freq));
    if (problem) {
      fail(problem);
      return;
    }

    payBtn.disabled = true;
    payBtn.textContent = "Just a moment…";

    buildCart(true)
      .then(function () {
        window.location.href = "/checkout";
      })
      .catch(function (e) {
        fail("Sorry, we could not start your order. " + (e && e.message ? e.message : "Please try again."));
      });
  });

  /* -------------------------------------------------------- discount code */
  /* Codes are Shopify's own. The only way to know if one works on this box is
     to put the box in the cart and ask, so that is what Apply does. The total
     shown after is Shopify's own total, and the code is already on the cart
     when checkout opens, so nobody types it twice. */
  var codeOpenBtn = document.getElementById("rr-code-open");
  var codeForm = document.getElementById("rr-code-form");
  var codeIn = document.getElementById("rr-code-in");
  var codeApply = document.getElementById("rr-code-apply");
  var codeOn = document.getElementById("rr-code-on");
  var codeOnTxt = document.getElementById("rr-code-on-txt");
  var codeMsg = document.getElementById("rr-code-msg");

  var wantedCode = "";
  var applied = null;
  var codeTurn = 0;
  /* True once Shopify has accepted a code in this visit. A code that came in
     on a link (?discount=) sits in wantedCode from the first paint, but it
     has not been checked yet, and it must not make a tap on a size build the
     cart: that would report an add to cart before the shopper chose. */
  var codeLive = false;

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* A code can arrive two ways without the shopper typing it: ?discount= on a
     link to this page, or Shopify's own /discount/CODE link, which leaves a
     discount_code cookie behind on whatever page it redirects to. */
  function startingCode() {
    var q = new URLSearchParams(window.location.search).get("discount");
    if (q) { return q.trim(); }
    var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
    return m ? decodeURIComponent(m[1]).trim() : "";
  }

  /* Otherwise a code the shopper removed comes back on the next visit. */
  function forgetCookie() {
    document.cookie = "discount_code=; path=/; max-age=0";
  }

  function codeView(v) {
    codeOpenBtn.hidden = v !== "closed";
    codeForm.hidden = v !== "open";
    codeOn.hidden = v !== "on";
    codeOpenBtn.setAttribute("aria-expanded", v === "open" ? "true" : "false");
  }

  function say(text, bad) {
    codeMsg.textContent = text;
    codeMsg.className = "fcode-msg" + (bad ? " bad" : "");
  }

  function busy(on) {
    codeApply.disabled = on;
    codeApply.textContent = on ? "Checking…" : "Apply";
  }

  function paintTotal() {
    var b = boxByKey(state.box);
    var row = document.getElementById("rr-s-disc");
    var tot = document.getElementById("rr-s-total");
    if (applied && b) {
      document.getElementById("rr-s-disc-code").textContent = applied.code;
      document.getElementById("rr-s-disc-amt").textContent = "−" + money(applied.off);
      row.hidden = false;
      tot.innerHTML = "<s>" + esc(b.priceText) + "</s> " + esc(money(applied.total));
    } else {
      row.hidden = true;
      tot.textContent = b ? b.priceText : "—";
    }
  }

  function tryCode(code) {
    code = String(code || "").trim().toUpperCase();
    if (!code) {
      say("Type your code first.", true);
      codeIn.focus();
      return;
    }
    var mine = ++codeTurn;
    wantedCode = code;
    applied = null;
    paintTotal();
    codeIn.value = code;
    codeView("open");
    busy(true);
    say("Checking your code…", false);

    buildCart(true).then(function (cart) {
      if (mine !== codeTurn) { return; }
      busy(false);
      var hit = (cart.discount_codes || []).filter(function (d) {
        return String(d.code).toUpperCase() === code;
      })[0];
      if (hit && hit.applicable && cart.total_discount > 0) {
        applied = { code: code, off: cart.total_discount, total: cart.total_price };
        codeLive = true;
        codeOnTxt.textContent = code + " applied. You save " + money(cart.total_discount) + ".";
        codeView("on");
        say("", false);
      } else {
        wantedCode = "";
        codeLive = false;
        forgetCookie();
        say("That code doesn't work on this box. Check the spelling, or try another code.", true);
        codeIn.focus();
        codeIn.select();
      }
      paintTotal();
    }, function () {
      if (mine !== codeTurn) { return; }
      busy(false);
      wantedCode = "";
      codeLive = false;
      say("We couldn't check that code just now. Please try again.", true);
      paintTotal();
    });
  }

  /* A code accepted on step 1 was accepted for that box. A different size
     can change the saving, or whether the code applies at all, so check it
     again. The pause lets a quick run of taps settle into one check. */
  var recheckTimer = null;

  function recheckSoon() {
    if (!codeLive || !wantedCode) { return; }
    clearTimeout(recheckTimer);
    recheckTimer = setTimeout(function () { tryCode(wantedCode); }, 350);
  }

  codeOpenBtn.addEventListener("click", function () {
    codeView("open");
    codeIn.focus();
  });

  codeApply.addEventListener("click", function () {
    tryCode(codeIn.value);
  });

  codeIn.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      tryCode(codeIn.value);
    }
  });

  document.getElementById("rr-code-remove").addEventListener("click", function () {
    codeTurn++;
    wantedCode = "";
    applied = null;
    codeLive = false;
    forgetCookie();
    codeIn.value = "";
    codeView("closed");
    say("", false);
    paintTotal();
    codeOpenBtn.focus();
    /* The code is still on the cart from the check. Take it off now, in the
       queue, so nothing that reads the cart before checkout sees it. */
    var off = function () { return postJSON("/cart/update.js", { discount: "" }); };
    cartQueue = cartQueue.then(off, off).catch(function () {});
  });

  /* --------------------------------------------------- first paint + URL */
  function preselect() {
    preloadPhotos();
    placeCode(1);
    wantedCode = startingCode().toUpperCase();
    if (wantedCode) { codeIn.value = wantedCode; }
    var q = new URLSearchParams(window.location.search);

    var pick = null;
    var wanted = (q.get("size") || "").toLowerCase();
    if (wanted) {
      DATA.boxes.forEach(function (b) {
        if (!pick && String(b.name).toLowerCase() === wanted) { pick = b.key; }
      });
    }
    if (!pick) {
      var flagged = root.querySelector("[data-box] .badge");
      if (flagged) { pick = flagged.closest("[data-box]").getAttribute("data-box"); }
    }
    if (!pick && DATA.boxes.length) { pick = DATA.boxes[0].key; }
    state.box = pick;

    if (DATA.freqs.length) { state.freq = DATA.freqs[0].key; }
    syncPicks();

    var pc = q.get("postcode");
    if (pc && /^\d{4}$/.test(pc)) {
      pcInput.value = pc;
      pcInput.dispatchEvent(new Event("input"));
    }
  }

  if (window.RR) {
    preselect();
  } else {
    window.addEventListener("DOMContentLoaded", preselect);
  }
})();
